import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const FeedbackProcedureRequest = {
  getFeedbackProcedureList: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/feedback-procedure/all`,
      params: {
        page: params.page,
        size: params.size,
        title: params.title,
        startDate: params.startDate,
        endDate: params.endDate,
      },
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      // params: params,
    }),

  createFeedbackProcedure: dataSubmit =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/feedback-procedure`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: dataSubmit,
    }),

  getFeedbackProcedureById: code =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/feedback-procedure/detail/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  getFeedbackProcedureFileName: fileid =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/feedback-procedure/file/${fileid}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  getFeedbackProcedureByCode: code =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/feedback-procedure/view/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  updateFeedbackProcedure: (data, code) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/feedback-procedure/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: data,
    }),

  deleteFeedbackProcedure: code =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/feedback-procedure/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  updateFeedbackProcedureStatus: (data, code) =>
    axios({
      method: 'patch',
      url: `${apiUrl}/api/v1/feedback-procedure/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: data,
    }),

  updateFileElectronic: (file_id, action, code) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/feedback-procedure/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: {
        file_id: file_id,
        action: action,
      },
    }),

  deleteFeedbackProcedure: id =>
    axios({
      method: 'DELETE',
      url: `${apiUrl}/api/v1/feedback-procedure/delete/${id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  // comment
  getCommentFeedbackProcedureList: code =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/feedback-procedure/${code}/comments`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  createCommentFeedbackProcedure: (code, data) =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/feedback-procedure/${code}/comments`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: data,
    }),

  deleteCommentFeedbackProcedure: (code, id_comment) =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/feedback-procedure/${code}/comments/${id_comment}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
}
